/**
 * Backend ChatMessageType enum + URL field mapping.
 * Upload media first, then emit client:sendPrivateMessage with the matching type + URL.
 */
export const ChatMessageType = {
  TEXT: "text",
  IMAGE: "image",
  VIDEO: "video",
  FILES: "files",
  AUDIO: "audio",
  RECORD: "record",
};

/** Socket payload URL key for each media type. */
const MEDIA_URL_FIELD = {
  [ChatMessageType.IMAGE]: "imageUrl",
  [ChatMessageType.VIDEO]: "videoUrl",
  [ChatMessageType.AUDIO]: "audioUrl",
  [ChatMessageType.RECORD]: "audioUrl",
  [ChatMessageType.FILES]: "fileUrl",
};

export const mediaUrlFieldForType = (messageType) =>
  MEDIA_URL_FIELD[String(messageType || "").toLowerCase()] || null;

/**
 * Build type-specific URL fields for the socket payload.
 * TEXT → { text }; media → { imageUrl | videoUrl | audioUrl | fileUrl }.
 */
export const buildMessageTypeFields = (messageType, { text = "", url = "" } = {}) => {
  const type = String(messageType || ChatMessageType.TEXT).toLowerCase();

  if (type === ChatMessageType.TEXT) {
    return { messageType: ChatMessageType.TEXT, text };
  }

  const urlField = mediaUrlFieldForType(type);
  const fields = { messageType: type };
  if (urlField && url) fields[urlField] = url;
  // Optional caption — not required by backend for media types
  if (text) fields.text = text;
  return fields;
};

/** Infer socket messageType from a File / Blob. */
export const detectMessageType = (file) => {
  const mime = String(file?.type || "").toLowerCase();
  if (mime.startsWith("image/")) return ChatMessageType.IMAGE;
  if (mime.startsWith("video/")) return ChatMessageType.VIDEO;
  if (mime.startsWith("audio/")) return ChatMessageType.AUDIO;
  return ChatMessageType.FILES;
};

export const isPreviewableMedia = (messageType) => {
  const type = String(messageType || "").toLowerCase();
  return (
    type === ChatMessageType.IMAGE ||
    type === ChatMessageType.VIDEO ||
    type === ChatMessageType.AUDIO ||
    type === ChatMessageType.RECORD
  );
};
